const Service = (props) => {
  return (
    <div className="flex mx-7 lg:mx-10 2xl:mx-28 pb-7 md:pb-28">
      <div className="grid md:grid-cols-2 xl:grid-cols-3">
        <div className="p-5 lg:p-7 xl:pt-10 xl:pb-20 xl:px-20 flex flex-col border border-gray-200">
          <a href="/vlsi/designverification">
            <span className="font-headline flex text-blue-500 font-extrabold text-lg">
              01
            </span>
            <span className="flex my-6">
              <p className="font-headline text-2xl lg:text-3xl font-extrabold">
                Digital SoC DV with tailored UVM and VIP models
              </p>
            </span>
            <span className="flex">
              <p className="font-headline text-xl lg:text-2xl font-medium">
                SV design, UVM verification, and VIP models for custom digital
                hardware
              </p>
            </span>
          </a>
        </div>

        <div className="p-5 lg:p-7 xl:pt-10 xl:pb-20 xl:px-20 flex flex-col border border-gray-200">
          <a href="/vlsi/physicaldesign">
            <span className="font-headline flex text-blue-500 font-extrabold text-lg">
              02
            </span>
            <span className="flex my-6">
              <p className="font-headline text-2xl lg:text-3xl font-extrabold">
                Physical chip design, verification, and testing
              </p>
            </span>
            <span className="flex">
              <p className="font-headline text-xl lg:text-2xl font-medium">
                Backend services including semi-custom layout, verification,
                PnR, and testing
              </p>
            </span>
          </a>
        </div>
        <div className="p-5 lg:p-7 xl:pt-10 xl:pb-20 xl:px-20 flex flex-col border border-gray-200">
          <a href="/vlsi/IC-Packaging">
            <span className="font-headline flex text-blue-500 font-extrabold text-lg">
              03
            </span>
            <span className="flex my-6">
              <p className="font-headline text-2xl lg:text-3xl font-extrabold">
              IC Package Design
              </p>
            </span>
            <span className="flex">
              <p className="font-headline text-xl lg:text-2xl font-medium">
              Safeguard Your Device's Core with Our Expertise for Enhanced Device Protection
              </p>
            </span>
          </a>
        </div>
        <div className="p-5 lg:p-7 xl:pt-10 xl:pb-20 xl:px-20 flex flex-col border border-gray-200">
          <a href="/vlsi/firmware">
            <span className="font-headline flex text-blue-500 font-extrabold text-lg">
              04
            </span>
            <span className="flex my-6">
              <p className="font-headline text-2xl lg:text-3xl font-extrabold">
                Bridge the gap between hardware and software
              </p>
            </span>
            <span className="flex">
              <p className="font-headline text-xl lg:text-2xl font-medium">
                Application driven system development for IoT, 5G, and smart
                devices also
              </p>
            </span>
          </a>
        </div>
        <div className="p-5 lg:p-7 xl:pt-10 xl:pb-20 xl:px-20 flex flex-col border border-gray-200">
          <a href="/vlsi/infrastructure">
            <span className="font-headline flex text-blue-500 font-extrabold text-lg">
              05
            </span>
            <span className="flex my-6">
              <p className="font-headline text-2xl lg:text-3xl font-extrabold">
                Infrastructural build setup and maintenance
              </p>
            </span>
            <span className="flex">
              <p className="font-headline text-xl lg:text-2xl font-medium">
                Amazon AWS and other secure infrastructure capability with
                robust IT support
              </p>
            </span>
          </a>
        </div>
        {/*  */}
      </div>
    </div>
  );
};

export default Service;
